import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import type { PaymentCallbackStatus } from "./payment-copy";

const markClass =
  "flex h-16 w-16 items-center justify-center rounded-full transition-colors duration-300 ease-out";

export function PaymentStatusMark({ status }: { status: PaymentCallbackStatus }) {
  if (status === "verifying") {
    return (
      <div className={`${markClass} bg-primary/10 text-primary`} role="status">
        <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
        <span className="sr-only">Confirming payment</span>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className={`${markClass} bg-success-50 text-success-700`}>
        <CheckCircle2 className="h-8 w-8" aria-hidden />
      </div>
    );
  }

  return (
    <div className={`${markClass} bg-danger-50 text-danger`} role="alert">
      <XCircle className="h-8 w-8" aria-hidden />
    </div>
  );
}
